<template>
  <div v-redirect-if-no-permission:MARKETING_VOUCHERS :key="switch1">
    <loading-component :value="loading" />
    <v-btn color="primary" dark class="mb-2 sbtn" @click="dialog = true">{{ $t("vouchersPage.new") }}</v-btn>
    <DataTable ref="dataTable" :url="'voucher'" :enable-edit="false" :enable-add="false"
      :formatter="formatters" :actions-extra-main="actionsExtraMain" perPage="10" :fields-hidden-main="['full_name','type']"
      :titles="titles" :title='$t("vouchersPage.pageTitleMarketingPending")' :initial-url-search-params="tableParams" />

    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card style="padding: 10px;">
        <v-card-title>
          <span class="headline">
            {{ $t("vouchersPage.addVoucherTitle") }}
          </span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form :key="formKey" ref="addForm">
            <v-text-field :rules="[rules.required]" :label='$t("vouchersPage.title")' type="text" v-model="model.title" />
            <v-text-field :rules="[rules.required]" :label='$t("vouchersPage.code")' type="text" v-model="model.code" />
            <v-select :label='$t("vouchersPage.discountType")' :items="discountTypeItems" :rules="[rules.required]"
              v-model="model.discount_type" />
            <v-text-field :rules="[rules.required, rules.number]" :label='$t("vouchersPage.amount")' type="text" v-model="model.amount" />

            <choose-date :rules="[rules.required]" :label='$t("vouchersPage.startDate")' v-model="model.start_date"></choose-date>
            <choose-date :rules="[rules.required]" :label='$t("vouchersPage.endDate")' v-model="model.end_date"></choose-date>

            <v-text-field :rules="[rules.required, rules.number]" :label='$t("vouchersPage.maxRedemption")' type="number"
              v-model="model.max_redemption" />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" style="width: 50%;" :loading="dialogLoading" flat @click="addVoucher()">{{ $t("vouchersPage.add") }}</v-btn>
          <v-btn color="primary" style="width: 50%;" :loading="dialogLoading" flat
            @click="dialog = false">{{ $t("vouchersPage.cancel") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";
import LoadingComponent from "@/components/LoadingComponent";
import ChooseDate from "@/components/monaco/input/ChooseDate";
import { formatMoney } from "@/mixins/money";

export default {
  name: "MarketingPendingVouchers",
  title() {
    return this.$t("vouchersPage.pageTitleMarketingPending");
  },
  components: {
    LoadingComponent,
    DataTable,
    ChooseDate
  },
  data() {
    return {
      formKey: 0,
      rules: {
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("vouchersPage.ruleLength", { len }),
        required: (v) => !!v || this.$t("vouchersPage.ruleRequired"),
        number: (v) => /^\d+(\.\d+)?$/.test(v) || this.$t("vouchersPage.ruleNumber")
      },
      loading: false,
      dialogLoading: false,
      dialog: false,
      selectedCaptain: null,
      model: {
        title: "",
        code: "",
        discount_type: "PERCENTAGE",
        amount: "",
        start_date: "",
        end_date: "",
        type: "PROMOTIONAL",
        max_redemption: null
      },
      switch1: null,
    };
  },

  computed: {
    formatters() {
      return {
        created_at(value) {
          return value ? formatCompanyTime(value, "YYYY-MM-DD") : "";
        },
        admin_name: (value) => value || this.$t("vouchersPage.system"),
        discount_type: (value) =>
          value == "PERCENTAGE" ? "%" : this.$t("vouchersPage.discountTypeFixed"),
        amount(value, item) {
          // Voucher amount is MONEY only for FIXED vouchers; for PERCENTAGE it is
          // a percent value and must NOT be scaled.
          return item && item.discount_type === "PERCENTAGE"
            ? value
            : formatMoney(value);
        },
        used_amount(value) {
          // Realized discount amount (currency consumed) -> always money.
          return formatMoney(value);
        },
        active(val) {
          return `
                        <i class="v-icon fa ${val ? "fa-check" : "fa-close"
            }"></i>
                        `;
        },
      };
    },
    discountTypeItems() {
      return [
        { text: this.$t("vouchersPage.discountTypePercentage"), value: "PERCENTAGE" },
        { text: this.$t("vouchersPage.discountTypeFixed"), value: "FIXED" },
      ];
    },
    titles() {
      return {
        id: "#",
        title: this.$t("vouchersPage.title"),
        code: this.$t("vouchersPage.code"),
        discount_type: this.$t("vouchersPage.discountType"),
        amount: this.$t("vouchersPage.amount"),
        start_date: this.$t("vouchersPage.startDate"),
        end_date: this.$t("vouchersPage.endDate"),
        use_times: this.$t("vouchersPage.useTimes"),
        max_redemption: this.$t("vouchersPage.maxRedemption"),
        used_amount: this.$t("vouchersPage.usedAmount"),
        admin_name: this.$t("vouchersPage.createdBy"),
        active: this.$t("vouchersPage.active"),
        created_at: this.$t("vouchersPage.creationDate")
      };
    },
    tableParams() {
      const params = new URLSearchParams();
      params.append("pending", true);
      params.append("type", "PROMOTIONAL");
      return params;
    },
    actionsExtraMain() {
      return {

      };
    },

  },
  watch: {

    dialog: function (val) {
      this.dialogLoading = false;
      if (val)
        this.formKey++;
      else
      this.resetModel();


    },
  },
  methods: {
    resetModel() {
      this.model = {
        title: "",
        code: "",
        discount_type: "PERCENTAGE",
        amount: "",
        start_date: "",
        end_date: "",
        type: "PROMOTIONAL",
        max_redemption: null
      };
    },
    addVoucher() {

      const form = this.$refs.addForm;
      if (!form.validate()) {
        return;
      }

      this.dialogLoading = true;
      // Voucher amount is MONEY only for FIXED vouchers -> convert NEW-unit input
      // back to stored (old) units on submit. PERCENTAGE amounts are sent as-is.
      const payload = {
        ...this.model,
        amount:
          this.model.discount_type === "FIXED"
            ? this.toStoredAmount(this.model.amount)
            : this.model.amount,
      };
      this.axios
        .post(`voucher`, payload)
        .then(() => {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("vouchersPage.voucherAdded"),
            "green"
          );
           this.dialog = false;
          this.$refs.dataTable.getData();

        })
        .catch((err) => {
          this.dialogLoading = false;
          const errorMessage = (err.response && err.response.data && err.response.data.message)
            ? err.response.data.message
            : this.$t("vouchersPage.errorOccurred");
          window.getApp.$emit("SHOW_TOAST", errorMessage, "red");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.sbtn {
  float: inline-end;
  z-index: 1;
  margin-top: 20px;
  margin-inline-end: 20px;
  padding: 0px 45px;
}

.input {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 10px;

  label {
    font-size: 14px;
  }

  input {
    width: max-content;
    flex-grow: 1;
  }
}
</style>
